import { render, staticRenderFns } from "./ActiveBeacons.vue?vue&type=template&id=1b0b91f5"
import script from "./ActiveBeacons.vue?vue&type=script&lang=js"
export * from "./ActiveBeacons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports